import { NET } from '../data/balance';
import type { AuthCreds, AuthMode } from '../net/protocol';
import { focusAfterKey } from './focusAfterKey';

const LAST_ACCOUNT_KEY = 'maple-slice.lastAccount';
const LAST_SERVER_KEY = 'maple-slice.netUrl';

type Ok = (creds: AuthCreds) => void;

export class AuthOverlay {
  static blocking = false;

  private static onOk: Ok | null = null;

  static show(onOk: Ok): void {
    this.onOk = onOk;
    this.blocking = true;
    const dock = document.getElementById('auth-dock');
    if (dock) dock.hidden = false;
    const account = document.getElementById('auth-account') as HTMLInputElement | null;
    const nick = document.getElementById('auth-nick') as HTMLInputElement | null;
    const err = document.getElementById('auth-error');
    if (err) err.textContent = '';
    if (nick) nick.maxLength = NET.nickMax;
    if (account && !account.value) {
      account.value = localStorage.getItem(LAST_ACCOUNT_KEY) ?? '';
    }
    const server = document.getElementById('auth-server') as HTMLInputElement | null;
    if (server && !server.value) {
      server.value = localStorage.getItem(LAST_SERVER_KEY) ?? '';
    }
    focusAfterKey(account);
  }

  static hide(): void {
    this.blocking = false;
    this.onOk = null;
    const dock = document.getElementById('auth-dock');
    if (dock) dock.hidden = true;
  }

  static error(message: string): void {
    const err = document.getElementById('auth-error');
    if (err) err.textContent = message;
  }

  static bind(): void {
    const login = document.getElementById('auth-login');
    const register = document.getElementById('auth-register');
    const cancel = document.getElementById('auth-cancel');
    login?.addEventListener('click', () => this.submit('login'));
    register?.addEventListener('click', () => this.submit('register'));
    cancel?.addEventListener('click', () => this.hide());
    for (const id of ['auth-account', 'auth-pass', 'auth-nick', 'auth-server']) {
      document.getElementById(id)?.addEventListener('keydown', (ev) => {
        ev.stopPropagation();
        if ((ev as KeyboardEvent).key === 'Enter') {
          ev.preventDefault();
          const nickVal = (document.getElementById('auth-nick') as HTMLInputElement | null)?.value.trim() ?? '';
          this.submit(nickVal ? 'register' : 'login');
        }
        if ((ev as KeyboardEvent).key === 'Escape') {
          ev.preventDefault();
          this.hide();
        }
      });
    }
    document.getElementById('auth-form')?.addEventListener('submit', (ev) => ev.preventDefault());
  }

  private static submit(mode: AuthMode): void {
    const account = (document.getElementById('auth-account') as HTMLInputElement | null)?.value.trim() ?? '';
    const password = (document.getElementById('auth-pass') as HTMLInputElement | null)?.value ?? '';
    const nick = (document.getElementById('auth-nick') as HTMLInputElement | null)?.value.trim() ?? '';
    if (!/^[a-zA-Z0-9]{3,16}$/.test(account)) {
      this.error('계정은 영문·숫자 3~16자');
      return;
    }
    if (password.length < NET.passMin) {
      this.error(`비밀번호 ${NET.passMin}자 이상`);
      return;
    }
    if (mode === 'register' && (nick.length < 2 || nick.length > NET.nickMax || nick.includes('/'))) {
      this.error(`닉네임 2~${NET.nickMax}자 (가입 시 필수)`);
      return;
    }
    const serverUrl = (document.getElementById('auth-server') as HTMLInputElement | null)?.value.trim() ?? '';
    localStorage.setItem(LAST_ACCOUNT_KEY, account);
    localStorage.setItem(LAST_SERVER_KEY, serverUrl);
    const cb = this.onOk;
    if (!cb) return;
    cb({ mode, account, password, nick, serverUrl });
  }
}
